import { MediaData } from './media-data';
import { SiteDocumentStatusEnum } from '../../enum/site-document-status.enum';
import { StaffSignatureData } from './staff-signature-data';
import { CustomerSignatureData } from './customer-signature-data';

/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

export class OffHireData {
  OffHireId: string;
  OffHireType: number;
  Scaffolds: string[];
  SiteId: string;
  CustomerId: string;
  RequestedBy: string;
  RequestedOn: string;
  OffHireReference: string;
  OffHireComments: string;
  Media: { [key: string]: MediaData };
  When: string;
  Status: SiteDocumentStatusEnum;
  StaffSignature: StaffSignatureData;
  CustomerSignature: CustomerSignatureData;
  Deleted: boolean;
  LastModified: string;
}


